var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"bullet",style:({ 'padding-left': (_vm.paddingLeft || 0) + 'px', 'padding-right': (_vm.paddingRight || 0) + 'px' })},[_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }